export const articles = [
  {
    id: 'a1',
    title: '2026暑期档票房突破80亿，国产影片领跑大盘',
    slug: '2026-summer-box-office',
    excerpt: '据最新数据统计，2026年暑期档总票房已突破80亿元人民币，其中国产影片贡献超过七成票房，多部现实主义题材影片口碑与票房双丰收。',
    content: `<p>据国家电影局最新发布的数据，截至8月7日，2026年暑期档（6月1日至8月31日）全国电影总票房已突破80亿元人民币，观影人次超过1.9亿。</p>
<p>其中，国产影片以超过七成的票房占比继续领跑大盘。特别是多部聚焦社会现实的影片，如《人间烟火》《向阳而生》等，凭借扎实的剧本和精良的制作，赢得了观众和影评人的一致好评。</p>
<p>业内人士分析指出，今年暑期档呈现出三个显著特点：一是类型片更加多元化，涵盖了喜剧、科幻、悬疑、动画等多个品类；二是现实主义题材回归，引发广泛社会共鸣；三是年轻导演群体崛起，为行业注入新鲜血液。</p>
<p>"今年暑期档的质量整体上了一个台阶，"知名影评人张凯表示，"观众越来越愿意为优质内容买单，这也倒逼创作者不断提升作品质量。"</p>
<p>此外，影院观影体验的持续升级也成为票房增长的重要推动力。IMAX、杜比影院等高端放映厅的上座率明显高于普通厅，反映出观众对高品质观影体验的追求。</p>
<p>预计随着8月中下旬多部重磅新片的上映，暑期档总票房有望冲击120亿元大关，再创历史新高。</p>`,
    categoryId: 'yule',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20movie%20theater%20interior%20with%20warm%20ambient%20lighting%2C%20premium%20cinema%20hall%20with%20red%20seats%2C%20large%20silver%20screen%20displaying%20abstract%20colorful%20visuals%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20with%20soft%20shadows%2C%20elegant%20composition&width=800&height=500&seq=article-a1&orientation=landscape',
    tags: ['暑期档', '票房', '国产电影', '电影市场'],
    author: '久久热编辑组',
    publishedAt: '2026-08-07',
    viewCount: 128500,
    isHot: true,
    isTrending: true,
  },
  {
    id: 'a2',
    title: 'AI大模型进入"平民化"时代：普通人如何拥抱人工智能变革',
    slug: 'ai-democratization-2026',
    excerpt: '随着各大科技公司纷纷推出轻量级AI模型和低门槛开发工具，人工智能正在从实验室走向千家万户，改变着普通人的工作与生活方式。',
    content: `<p>2026年，人工智能领域迎来了一个重要的转折点——AI大模型正在从"高大上"的技术概念，转变为普通人触手可及的日常工具。</p>
<p>过去一年中，国内外科技巨头纷纷推出了面向普通用户的轻量级AI产品。从智能写作助手到AI绘画工具，从语音助手到智能家居控制，AI正在以润物细无声的方式融入我们的日常生活。</p>
<p>"现在已经不是讨论'要不要用AI'的问题，而是'怎么用好AI'的问题，"科技评论人李明辉指出，"AI正在成为像电力和互联网一样的基础设施。"</p>
<p>在教育领域，AI辅导工具帮助学生们更高效地学习；在医疗领域，AI辅助诊断系统提高了基层医疗机构的诊疗水平；在创意产业，AI工具降低了内容创作的门槛，让更多人能够表达自己的创意。</p>
<p>然而，专家也提醒，在享受AI带来便利的同时，需要关注数据隐私、算法偏见等潜在风险，建立健全的AI治理框架至关重要。</p>`,
    categoryId: 'keji',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20minimalist%20workspace%20with%20woman%20interacting%20with%20holographic%20AI%20interface%2C%20soft%20neutral%20tones%2C%20warm%20ambient%20light%2C%20clean%20modern%20design%2C%20editorial%20photography%20style%2C%20harmonious%20composition&width=800&height=500&seq=article-a2&orientation=landscape',
    tags: ['人工智能', 'AI', '科技趋势', '数字化'],
    author: '久久热科技频道',
    publishedAt: '2026-08-06',
    viewCount: 95600,
    isHot: true,
    isTrending: true,
  },
  {
    id: 'a3',
    title: '可持续时尚成为主流：环保面料如何重塑服装产业',
    slug: 'sustainable-fashion-2026',
    excerpt: '从再生纤维到生物基材料，可持续时尚正在从边缘走向主流。越来越多的品牌将环保理念融入设计与生产，消费者也用实际行动投票。',
    content: `<p>在2026年的时尚舞台上，"可持续"已不再是一个选配标签，而是行业的新标准。从国际奢侈品牌到本土设计师品牌，环保面料的应用正在以前所未有的速度扩展。</p>
<p>据中国纺织工业联合会的数据显示，2026年上半年，采用环保认证面料的服装产品同比增长了45%，其中再生聚酯纤维和有机棉的使用量分别增长了60%和35%。</p>
<p>"消费者的环保意识觉醒是推动这一变革的核心动力，"时尚产业分析师王雅琪表示，"尤其是Z世代消费者，他们更愿意为可持续产品支付溢价。"</p>
<p>在技术层面，生物基材料的突破性进展也为可持续时尚提供了新的可能。蘑菇皮革、菠萝纤维、海藻面料等创新材料开始从实验室走向商业化生产。</p>
<p>不过，业内专家也指出，真正的可持续不仅是材料的选择，更涉及整个供应链的绿色转型，包括减少水资源消耗、降低碳排放、改善劳工条件等多个维度。</p>`,
    categoryId: 'shishang',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20designer%20studio%20with%20natural%20eco-friendly%20fabric%20rolls%20in%20neutral%20earth%20tones%2C%20warm%20soft%20lighting%2C%20sustainable%20textiles%20displayed%20beautifully%2C%20editorial%20interior%20photography%2C%20clean%20harmonious%20composition&width=800&height=500&seq=article-a3&orientation=landscape',
    tags: ['可持续时尚', '环保面料', '服装产业', '绿色消费'],
    author: '久久热时尚频道',
    publishedAt: '2026-08-05',
    viewCount: 67200,
    isHot: true,
    isTrending: false,
  },
  {
    id: 'a4',
    title: '巴黎奥运会倒计时两周年：各大场馆建设进入冲刺阶段',
    slug: 'paris-olympics-countdown',
    excerpt: '距离2028年洛杉矶奥运会还有两年，各项筹备工作进入关键阶段。从场馆建设到志愿者招募，主办方正全力以赴迎接这场全球体育盛事。',
    content: `<p>虽然距离2028年洛杉矶奥运会还有整整两年时间，但筹备工作的节奏已经明显加快。洛杉矶奥组委近日宣布，主要场馆的建设已进入冲刺阶段，多个项目将在未来六个月内陆续完工。</p>
<p>作为2028年奥运会的核心场馆，洛杉矶纪念体育场（Los Angeles Memorial Coliseum）的翻新工程已完成85%。这座历史悠久的场馆将成为奥运史上首个举办过三届奥运会开闭幕式的场地。</p>
<p>在运动员备战方面，中国体育代表团的多支队伍的奥运集训计划已经全面展开。国家体育总局表示，将在保持传统优势项目竞争力的同时，重点突破游泳、田径等基础大项。</p>
<p>"奥运会的意义远超体育本身，"国际奥委会委员表示，"它是一种凝聚全球力量、传递和平与友谊的精神象征。"</p>`,
    categoryId: 'tiyu',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Olympic%20stadium%20aerial%20view%20at%20golden%20sunset%20hour%2C%20grand%20sports%20architecture%20with%20warm%20atmospheric%20lighting%2C%20sweeping%20wide%20angle%20shot%2C%20majestic%20composition%2C%20editorial%20sports%20photography&width=800&height=500&seq=article-a4&orientation=landscape',
    tags: ['奥运会', '洛杉矶2028', '体育盛事', '场馆建设'],
    author: '久久热体育频道',
    publishedAt: '2026-08-04',
    viewCount: 84100,
    isHot: false,
    isTrending: true,
  },
  {
    id: 'a5',
    title: '城市微旅行兴起：年轻人用脚步重新发现身边的美好',
    slug: 'city-micro-travel-trend',
    excerpt: '不需要远行，不必做攻略，"城市微旅行"成为2026年最受欢迎的休闲方式之一。年轻人们开始用探索的心态重新打量自己生活的城市。',
    content: `<p>"以前总觉得旅行就要去很远的地方，后来才发现，我家附近那条从未走过的小巷里藏着一家超棒的独立书店。"28岁的陈雨是一名设计师，她最近迷上了"城市微旅行"——在自己的城市里，像一个游客一样去探索未知的角落。</p>
<p>这种旅行方式的兴起，与当代年轻人的生活方式变化密切相关。工作节奏快、假期碎片化，使得长途旅行变得更加奢侈。而城市微旅行只需要一个下午甚至一两个小时，就能获得新鲜的体验和放松的心情。</p>
<p>社交媒体上，城市微旅行相关话题的浏览量和内容创作量在过去半年中增长了超过200%。从Citywalk到胡同探秘，从老字号美食打卡到独立咖啡馆巡礼，各种玩法层出不穷。</p>
<p>社会学专家分析认为，城市微旅行的流行反映了年轻人对生活品质的新追求："他们不再满足于表面的观光，而是渴望深入体验和情感连接，哪怕是在最熟悉的环境里。"</p>`,
    categoryId: 'shenghuo',
    coverImage: 'https://readdy.ai/api/search-image?query=Young%20couple%20exploring%20charming%20urban%20alleyway%20with%20cobblestone%20path%2C%20warm%20afternoon%20sunlight%20filtering%20through%20trees%2C%20vintage%20shopfronts%20and%20cafes%2C%20lifestyle%20editorial%20photography%2C%20natural%20candid%20moment%2C%20warm%20harmonious%20composition&width=800&height=500&seq=article-a5&orientation=landscape',
    tags: ['城市微旅行', '生活方式', 'Citywalk', '年轻人'],
    author: '久久热生活频道',
    publishedAt: '2026-08-03',
    viewCount: 113200,
    isHot: true,
    isTrending: true,
  },
  {
    id: 'a6',
    title: '国产新能源车出海加速：欧洲市场成为中国品牌新战场',
    slug: 'china-ev-europe-expansion',
    excerpt: '中国新能源汽车品牌在欧洲市场的布局持续加速，凭借技术优势和性价比，正在改写全球汽车产业格局。',
    content: `<p>2026年上半年，中国新能源汽车出口量再创新高，其中欧洲市场成为增长最快的海外市场。比亚迪、蔚来、小鹏等品牌在欧洲多国的市场份额持续攀升。</p>
<p>数据显示，中国品牌纯电动车在欧盟市场的占有率已从2024年的8%提升至2026年上半年的18%。这一增长背后，是中国车企在电池技术、智能驾驶和供应链方面的综合优势。</p>
<p>"中国新能源汽车的竞争力已经得到了全球市场的认可，"汽车行业分析师刘志强指出，"这不仅仅是价格优势，更体现在产品力和服务体验上。"</p>
<p>不过，随着欧盟对中国电动汽车加征关税的讨论升温，中国品牌在欧洲的发展也面临着新的挑战。多位业内人士表示，本地化生产和供应链布局将是破局的关键。</p>
<p>目前，比亚迪已在匈牙利建立欧洲首个乘用车生产基地，预计2027年投产。其他品牌也在积极评估欧洲建厂的可能性。</p>`,
    categoryId: 'zixun',
    coverImage: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20electric%20SUV%20car%20on%20scenic%20European%20coastal%20road%20at%20sunset%2C%20clean%20futuristic%20design%2C%20warm%20golden%20light%2C%20automotive%20editorial%20photography%2C%20cinematic%20atmosphere%2C%20harmonious%20composition&width=800&height=500&seq=article-a6&orientation=landscape',
    tags: ['新能源汽车', '出海', '欧洲市场', '国产车'],
    author: '久久热资讯频道',
    publishedAt: '2026-08-02',
    viewCount: 78200,
    isHot: true,
    isTrending: false,
  },
  {
    id: 'a7',
    title: '从配角到主角：国产综艺如何实现口碑逆袭',
    slug: 'chinese-variety-show-renaissance',
    excerpt: '曾经被诟病"低质""抄袭"的国产综艺，正在经历一场静悄悄的革命。创新模式、深度内容和精良制作让一批新综艺收获口碑与热度。',
    content: `<p>如果你对国产综艺的印象还停留在"尬笑""剧本""抄袭"的阶段，那么2026年的综艺市场可能会让你刮目相看。</p>
<p>从人文纪实类《了不起的我们》到科普竞演类《火星建造者》，一批模式新颖、制作精良的原创综艺在2026年集中爆发。这些节目不仅在收视率和网络热度上取得了亮眼成绩，更在豆瓣等评分平台获得了8分以上的高分。</p>
<p>"国产综艺正在走出自己的路，"资深电视制作人陈浩表示，"过去我们总是在模仿韩综、美综的模式，但现在创作者们有了更多文化自信，开始从中国本土文化和现实生活中寻找灵感。"</p>
<p>以《了不起的我们》为例，这档聚焦普通人不平凡故事的纪实综艺，没有流量明星、没有激烈对抗，却凭借真实的情感和精良的叙事收获了现象级热度。</p>`,
    categoryId: 'yule',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20TV%20production%20studio%20with%20professional%20lighting%20equipment%20and%20cameras%2C%20creative%20atmosphere%2C%20warm%20ambient%20light%2C%20behind%20the%20scenes%20documentary%20style%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=500&seq=article-a7&orientation=landscape',
    tags: ['综艺', '国产综艺', '口碑逆袭', '原创内容'],
    author: '久久热编辑组',
    publishedAt: '2026-08-01',
    viewCount: 54100,
    isHot: false,
    isTrending: true,
  },
  {
    id: 'a8',
    title: '智能家居2.0：从单品智能到全屋智慧联动',
    slug: 'smart-home-2-upgrade',
    excerpt: '智能家居行业正在经历从"单品智能"到"全屋智慧联动"的升级。Matter协议统一标准后，不同品牌的设备终于可以无缝协作。',
    content: `<p>如果你家里已经有了智能音箱、智能灯和智能门锁，恭喜你，你已经体验了"智能家居1.0"。而现在，随着Matter协议的普及和AI技术的深度整合，智能家居正在迈向"2.0时代"——全屋智慧联动。</p>
<p>在智能家居2.0时代，不同品牌、不同类型的设备可以通过统一的标准实现互联互通。早上起床时，窗帘自动打开、咖啡机开始工作、音响播放你喜欢的音乐——这一切不再是科幻电影中的场景。</p>
<p>据市场研究机构预测，2026年全球智能家居市场规模将达到1800亿美元，中国市场占比超过30%。小米、华为、美的等国内企业在这一领域持续发力。</p>
<p>"全屋智能的核心不是设备数量，而是场景化的智慧体验，"智能家居产品经理赵琳表示，"用户不需要手动操作每一个设备，系统会根据用户的习惯和实时环境自动做出最优调整。"</p>`,
    categoryId: 'keji',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20smart%20living%20room%20interior%20with%20subtle%20technology%20integrated%2C%20warm%20ambient%20lighting%2C%20clean%20scandinavian%20design%2C%20smart%20home%20devices%20blending%20seamlessly%2C%20editorial%20interior%20photography%2C%20harmonious%20composition&width=800&height=500&seq=article-a8&orientation=landscape',
    tags: ['智能家居', '物联网', '全屋智能', '科技生活'],
    author: '久久热科技频道',
    publishedAt: '2026-07-31',
    viewCount: 49300,
    isHot: false,
    isTrending: false,
  },
  {
    id: 'a9',
    title: '世界杯预选赛亚洲区：中国队关键战役在即',
    slug: 'world-cup-qualifier-china',
    excerpt: '2026世界杯亚洲区预选赛进入关键阶段，中国男足将在主场迎战直接竞争对手，这场比赛将直接影响出线形势。',
    content: `<p>2026年8月12日，中国男足国家队将在沈阳奥体中心迎来世界杯亚洲区预选赛的关键战役，对手是同样在争夺出线席位的阿联酋队。</p>
<p>目前亚洲区预选赛已进入第三阶段（18强赛），中国队所在的A组竞争异常激烈。日本队一骑绝尘，而中国队与沙特阿拉伯、阿联酋的积分差距仅有2分，每场比赛都可能改写出线格局。</p>
<p>中国队主教练在赛前发布会上表示，球队已经做好了充分准备，主场球迷的支持将是球队的重要力量。核心球员武磊、蒋光太等均状态良好。</p>
<p>"这是一场不能输的比赛，"队长吴曦在训练后接受采访时说道，"全队上下都清楚这场比赛的重要性，我们会为每一个球拼搏。"</p>
<p>数据显示，本场比赛的球票在开售后三小时内即告售罄，沈阳奥体中心届时将座无虚席。</p>`,
    categoryId: 'tiyu',
    coverImage: 'https://readdy.ai/api/search-image?query=Football%20stadium%20packed%20with%20passionate%20fans%20in%20red%20jerseys%20at%20night%2C%20dramatic%20stadium%20lighting%2C%20electric%20atmosphere%2C%20wide%20angle%20shot%20from%20stands%2C%20sports%20editorial%20photography%2C%20epic%20composition&width=800&height=500&seq=article-a9&orientation=landscape',
    tags: ['世界杯', '中国队', '预选赛', '足球'],
    author: '久久热体育频道',
    publishedAt: '2026-07-30',
    viewCount: 156300,
    isHot: true,
    isTrending: true,
  },
  {
    id: 'a10',
    title: '"数字游民"的中国实践：逃离一线城市后他们过得怎样',
    slug: 'digital-nomad-china',
    excerpt: '越来越多年轻人选择离开一线城市，以"数字游民"的身份在大理、安吉等宜居小城远程工作。这种生活方式究竟是自由还是另一种束缚？',
    content: `<p>清晨在大理的洱海边醒来，上午在共享办公空间处理工作，下午爬山或骑行——这是90后设计师林雨婷的日常。两年前她离开上海，成为了一名"数字游民"，如今在云南大理过着完全不同节奏的生活。</p>
<p>像林雨婷这样的"数字游民"在中国正在快速增长。据不完全统计，目前中国已有超过200万人在尝试或已转型为数字游民生活方式，大理、安吉、三亚、成都等城市成为热门目的地。</p>
<p>"我赚的可能没有在上海时多，但生活品质却提高了很多，"林雨婷说，"没有通勤、没有无意义的社交，我可以把更多时间花在自己真正在意的事情上。"</p>
<p>然而，数字游民的生活并非只有诗和远方。收入不稳定、社保缴纳困难、职业发展路径模糊等问题，也让不少人感到焦虑。一些受访者表示，在享受了一段时间的自由后，反而开始怀念团队协作的归属感。</p>
<p>社会学研究者认为，数字游民现象反映了年轻一代对工作与生活关系的新思考，但要真正实现可持续发展，还需要社会制度的配套完善。</p>`,
    categoryId: 'shenghuo',
    coverImage: 'https://readdy.ai/api/search-image?query=Remote%20worker%20with%20laptop%20on%20wooden%20table%20overlooking%20beautiful%20mountain%20lake%20scenery%2C%20warm%20natural%20sunlight%2C%20peaceful%20minimalist%20lifestyle%2C%20editorial%20photography%2C%20calm%20harmonious%20composition&width=800&height=500&seq=article-a10&orientation=landscape',
    tags: ['数字游民', '远程办公', '生活方式', '年轻人'],
    author: '久久热生活频道',
    publishedAt: '2026-07-29',
    viewCount: 89100,
    isHot: false,
    isTrending: true,
  },
  {
    id: 'a11',
    title: '2026秋冬时装周趋势解读：极简主义强势回归',
    slug: 'fw-2026-fashion-trends',
    excerpt: '在刚刚落幕的2026秋冬时装周上，极简主义以全新姿态回归。干净利落的剪裁、中性色调和功能性设计成为各大品牌的主旋律。',
    content: `<p>随着2026秋冬四大时装周的落幕，一个清晰的信号传递出来：极简主义正在以前所未有的强势姿态回归时尚舞台。</p>
<p>从巴黎到米兰，从纽约到伦敦，各大品牌纷纷在T台上演绎了各自对"新极简"的理解。与90年代的性冷淡风不同，2026秋冬的极简主义更加温暖、更具质感——设计师们在简约的廓形中融入了柔软的面料、精致的细节和微妙的色彩层次。</p>
<p>"这不是简单的做减法，"时尚评论人苏妍分析道，"而是在克制中寻找力量，在简单中体现精致。这种风格回应了当下人们对于'少即是多'生活哲学的认同。"</p>
<p>色彩方面，奶油白、燕麦色、深巧克力色和灰绿色成为本季的核心色调，取代了前几季流行的荧光色和大面积印花。</p>
<p>值得关注的是，多个中国设计师品牌在本届时装周上表现亮眼，用东方美学诠释了极简主义的新可能。</p>`,
    categoryId: 'shishang',
    coverImage: 'https://readdy.ai/api/search-image?query=Minimalist%20fashion%20runway%20show%20with%20models%20in%20neutral%20tone%20clean%20silhouette%20garments%2C%20soft%20dramatic%20spotlighting%2C%20elegant%20modern%20atmosphere%2C%20editorial%20fashion%20photography%2C%20refined%20harmonious%20composition&width=800&height=500&seq=article-a11&orientation=landscape',
    tags: ['时装周', '极简主义', '2026秋冬', '时尚趋势'],
    author: '久久热时尚频道',
    publishedAt: '2026-07-28',
    viewCount: 45800,
    isHot: false,
    isTrending: false,
  },
  {
    id: 'a12',
    title: '全球气候变化新警示：2026年7月创下历史最高温纪录',
    slug: 'climate-record-july-2026',
    excerpt: '世界气象组织最新数据显示，2026年7月全球平均气温再创历史新高。极端天气事件频发，各国加速推进碳中和目标。',
    content: `<p>世界气象组织（WMO）8月6日发布的最新报告显示，2026年7月全球平均地表气温达到16.95°C，较工业化前水平高出1.58°C，刷新了历史最高纪录。</p>
<p>报告指出，7月全球多地经历了极端高温天气。欧洲南部、北美西部和东亚部分地区出现了持续多日超过40°C的高温。同时，南亚和西非遭遇了创纪录的暴雨和洪水。</p>
<p>"这些数据再次敲响了警钟，"联合国气候变化框架公约执行秘书表示，"气候变化不是未来的威胁，而是正在发生的现实。我们需要采取更紧急、更有力的行动。"</p>
<p>在政策层面，多个国家在2026年宣布了更激进的减排目标。中国承诺在2030年前实现碳达峰后，正在加快推进能源结构转型，可再生能源装机容量持续快速增长。</p>
<p>然而，科学家们警告，按照目前的减排速度，全球气温上升控制在1.5°C以内的目标面临巨大挑战。</p>`,
    categoryId: 'zixun',
    coverImage: 'https://readdy.ai/api/search-image?query=Split%20landscape%20image%20showing%20climate%20contrast%2C%20one%20side%20dry%20cracked%20earth%20one%20side%20renewable%20energy%20wind%20turbines%2C%20dramatic%20atmospheric%20skies%2C%20documentary%20editorial%20style%2C%20thoughtful%20composition&width=800&height=500&seq=article-a12&orientation=landscape',
    tags: ['气候变化', '全球变暖', '极端天气', '碳中和'],
    author: '久久热资讯频道',
    publishedAt: '2026-08-07',
    viewCount: 103600,
    isHot: true,
    isTrending: true,
  },
];

export const getArticleById = (id: string) => articles.find((a) => a.id === id);

export const getArticlesByCategory = (categoryId: string) =>
  articles.filter((a) => a.categoryId === categoryId);

export const getHotArticles = () => articles.filter((a) => a.isHot);

export const getTrendingArticles = () => articles.filter((a) => a.isTrending);

export const getRelatedArticles = (articleId: string, limit = 3) =>
  articles
    .filter((a) => {
      const current = getArticleById(articleId);
      return current && a.id !== articleId && a.categoryId === current.categoryId;
    })
    .slice(0, limit);

export const getLatestArticles = (limit = 6) =>
  [...articles].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  ).slice(0, limit);